require('./sectionTemplateRule.i18n.json');
require('./sectionTemplateRule.tpl.html');

/*@ngInject*/
const SectionTemplateRuleController = function ($rootScope, $scope, $stateParams, $uibModal, $q, configurationConstant, localization, currentUserModel, authorizationConstants, sectionTemplateEditorModel, sectionTemplateApplicabilityType, loadingBarHandler, configurationMediator, dataSetUtil, umStudioConstant, ruleMediator) {

    $scope.viewModel = {
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CONFIG_SECTION_TEMPLATES),
        sectionTemplate: {},
        showRuleBuilder: false,
        ruleAction: null,
        sectionTemplateRuleActions: []
    };

    $scope.ruleActionObjects = null;

    function init() {
        loadModel();
        loadLocalization();
    }

    function loadModel() {
        loadDataSets().then(function () {
            loadRuleActions().then(function () {
                $scope.viewModel.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));

                if (!_.isNil($scope.viewModel.sectionTemplate)) {
                    $scope.viewModel.showRuleBuilder = !_.isNil($scope.viewModel.sectionTemplate.triggerRule) && $scope.viewModel.sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL;

                    if ($scope.viewModel.showRuleBuilder) {
                        translateRuleActionFromModel();
                    }
                }
            });
        });
    }

    function loadDataSets() {
        if (_.isEmpty($scope.viewModel.sectionTemplateRuleActions)) {
            return dataSetUtil.getDataSet({name: 'Section Template Rule Actions'}).then(function (dataSet) {
                $scope.viewModel.sectionTemplateRuleActions = _.map(dataSet.items, function (item) {
                    return {
                        name: item.name,
                        value: item.value
                    };
                });
            });
        } else {
            return $q.when();
        }
    }

    function loadRuleActions() {
        if (_.isNil($scope.ruleActionObjects)) {
            $scope.ruleActionObjects = {};

            return ruleMediator.getRuleActions('proposal section rules').then(function (ruleActions) {
                _.each(ruleActions, function (ruleAction) {
                    if (_.find($scope.viewModel.sectionTemplateRuleActions, {value: ruleAction.name})) {
                        ruleAction.parameters[0].value.entityUri = 'com.firstbest.data.DataItem:com.firstbest.data.DataItemKey::Section Template::' + $stateParams.sectionTemplateId;
                        $scope.ruleActionObjects[ruleAction.name] = ruleAction;
                    }
                });
            });
        } else {
            return $q.when();
        }
    }

    function loadLocalization() {
        localization.getTranslationByKey('sectionTemplateRule').then(function (translations) {
            $scope.viewModel.placeholders = {
                ruleAction: _.get(translations, 'placeholders.ruleAction')
            };

            $scope.viewModel.reviewRuleNotificationMessage = _.get(translations, 'reviewRuleNotificationMessage');
        });
    }

    function showValidateRuleModal(validateRuleResult) {
        var instance = $uibModal.open({
            templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
            controller: 'validateRuleModalController',
            windowClass: 'validateRuleModal',
            resolve: {
                options: function () {
                    return {
                        ruleText: validateRuleResult.ruleText,
                        error: validateRuleResult.errors
                    };
                }
            }
        });
        return instance.result;
    }

    function translateRuleActionFromModel() {
        if (!_.isEmpty($scope.viewModel.sectionTemplate.triggerRule.actions)) {
            $scope.viewModel.ruleAction = _.find($scope.viewModel.sectionTemplateRuleActions, {value: $scope.viewModel.sectionTemplate.triggerRule.actions[0].name});
        }
    }

    function translateRuleActionToModel() {
        if (!_.isNil($scope.viewModel.ruleAction)) {
            $scope.viewModel.sectionTemplate.triggerRule.actions = [$scope.ruleActionObjects[$scope.viewModel.ruleAction.value]];
        } else {
            $scope.viewModel.sectionTemplate.triggerRule.actions = [];
        }
    }

    $scope.reviewRule = function () {
        loadingBarHandler.showNotificationLoadingBar($scope.viewModel.reviewRuleNotificationMessage);

        return configurationMediator.validateRule($scope.viewModel.sectionTemplate.triggerRule).then(function (result) {
            showValidateRuleModal(result);
        }).finally(function () {
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
    };

    $scope.onChange = function () {
        sectionTemplateEditorModel.setUnsavedRuleChanges($scope.viewModel.sectionTemplate.id, true);
        $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
    };

    $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
        sectionTemplateEditorModel.setUnsavedRuleChanges($scope.viewModel.sectionTemplate.id, true);
        $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
    });

    $scope.onRuleActionSelect = function () {
        translateRuleActionToModel();
        $scope.onChange();
    };

    $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, function (event, sectionTemplateId) {
        if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
            loadModel();
        }
    });

    init();
};

angular.module('ums.configuration')
    .controller('sectionTemplateRuleController', SectionTemplateRuleController);
